export class ApiError {
  message: string = '';
  statusCode?: string;

  constructor(message: string, statusCode?: string) {
    this.message = message;
    this.statusCode = statusCode;
  }
}
